var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "powerbar-nav-shortcuts-bar",
      attrs: { id: "action-menu", "aria-label": "Application shortcuts" }
    },
    [
      _c("p", { staticClass: "powerbar-nav-shortcuts-bar__label" }, [
        _vm._v("Shortcuts")
      ]),
      _vm._v(" "),
      _vm._l(_vm.links, function(link) {
        return _c(
          "IconButton",
          {
            key: link.path,
            attrs: { href: link.path, title: link.label, onClick: link.onClick }
          },
          [
            _c(link.icon, {
              tag: "component",
              staticClass: "powerbar-nav-shortcuts-bar__action-icon-svg",
              attrs: {
                role: "image",
                pathId: link.pathId,
                "aria-hidden": "true"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none" }, [_vm._v(_vm._s(link.label))])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }